import React from "react";
import ReactDOM from 'react-dom';
import {PropTypes} from 'prop-types';
import {connect} from "react-redux";

import {closeModal} from "../../actions/modalActions";
import {Button, Card, CardBody, CardText, CardTitle, Col, Input, Row} from "reactstrap";


class MyPortal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}

    this.onClose = this.onClose.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  onClose(){
    if (this.props.item.onClose)
      this.props.item.onClose()
    this.props.onClose(this.props.item)
  }
  onConfirm(){
    if (this.props.item.onConfirm) {
      this.props.item.onConfirm(this.state);
      this.props.onClose(this.props.item);
    }
  }

  handleChange(e){
    this.setState({[e.target.id]: e.target.value})
  }

  render() {
    const { type } = this.props.item;
    if (type === 'confirm') {
      const { title, descr } = this.props.item;
      return (
        <div className="modal-wrapper">
          <Card>
            <CardBody className="justify-content-between">
              <CardTitle className="text-center">{title}</CardTitle>
              <CardText>{descr}</CardText>
              <Row>
                <Col>
                  <Button block color="danger" onClick={() => this.onConfirm()}>Confirm</Button>
                </Col>
                <Col xs>
                  <Button block onClick={() => this.onClose()}>Close</Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      )
    } else if (type === 'input') {
      const { title, descr, inputs } = this.props.item;
      return (
        <div className="modal-wrapper">
          <Card>
            <CardBody className="justify-content-between">
              <CardTitle className="text-center">{title}</CardTitle>
              <CardText>{descr}</CardText>
              { inputs && inputs.map((data)=><Input className="mb-2" {...data} onChange={this.handleChange}/>)}
              <Row>
                <Col>
                  <Button block color="success" onClick={this.onConfirm}>Confirm</Button>
                </Col>
                <Col xs>
                  <Button block onClick={() => this.onClose()}>Close</Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      )
    }
    return (
      <div></div>
    );
  }
}

class Modals extends React.Component {
  render() {
    const modals = this.props.modals.map((item,i) => <MyPortal key={i} ><Modal item={item} onClose={(item) => this.props.dispatch(closeModal(item))}/></MyPortal>)
    return (
      <div className="modals">
        {modals}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  modals: state.modals.modals
})

Modal.defaultProps = {
  item: {
    type: "confirm",
    title: "Default modal title",
    descr: "Default modal description",
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals)


// WEBPACK FOOTER //
// ./src/components/Modals/index.js